import React from 'react';

const NumberDisplay = ({ numbers, title }) => {
  if (!numbers || numbers.length === 0) {
    return null;
  }

  const getBallColorClass = (number) => {
    if (number >= 1 && number <= 10) {
      return 'ball-yellow';
    } else if (number >= 11 && number <= 20) {
      return 'ball-blue';
    } else if (number >= 21 && number <= 30) {
      return 'ball-red';
    } else if (number >= 31 && number <= 40) {
      return 'ball-gray';
    } else if (number >= 41 && number <= 45) {
      return 'ball-green';
    }
    return ''; // Default or error case
  };

  return (
    <div className="number-display-container">
      {title && <h3>{title}</h3>}
      <div className="numbers-list">
        {numbers.map((num, index) => (
          <span key={index} className={`lotto-number ${getBallColorClass(num)}`}>
            {num}
          </span>
        ))}
      </div>
    </div>
  );
};

export default NumberDisplay;

